<script setup>
import { ref } from "vue";
import Swal from "sweetalert2";
// import { useContactStore } from "./../Store/contactStore";
import Navbar from "@/components/Navbar.vue";
import HowWork from "@/components/HomeCompoent/HowWork.vue";
import WhyUs from "@/components/HomeCompoent/WhyUs.vue";
import Footer from "@/components/SharedUI/Footer.vue";
import { sendEmail } from "@/services/apiServices";
import {
  nameRules,
  emailRules,
  contactRules,
  messageRules,
} from "@/utils/validationRule"; // ✅ import from utils

const pageTitle = ref("Contact Us");
const formValid = ref(false);
const formRef = ref(null);

const form = ref({
  name: "",
  email: "",
  contact: "",
  message: "",
});

const handleSubmit = async () => {
  const { valid } = await formRef.value.validate();

  if (!valid) {
    Swal.fire({
      icon: "error",
      title: "Please fix the errors before submitting.",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1500,
    });
    return;
  }

  try {
    await sendEmail(form.value);
    Object.assign(form.value, {
      name: "",
      email: "",
      contact: "",
      message: "",
    });
    formRef.value.resetValidation();
    Swal.fire({
      icon: "success",
      title: "Email sent successfully",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1000,
    });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Failed to send message. Please try again.",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1500,
    });
  }
};
</script>

<template>
  <div id="content">
    <Navbar />

    <!-- Banner Section
    <HeaderSection :title="pageTitle" /> -->

    <!-- <v-card class="pa-4"> -->
      <!-- First Row: Icons with Text -->
      <v-container fluid class="py-5">
        <v-row justify="center" class="mb-5">
          <v-col cols="12" md="4" sm="6" class="text-center">
            <v-icon size="35" color="primary">mdi-map-marker</v-icon>
            <p class="mt-2">
              <strong>Address</strong> <br />
              Bharatpur, Chitwan, Nepal
              <!-- {{ statedata.schoolAddress.province }}, {{ statedata.schoolAddress.municipality }} -->
            </p>
          </v-col>
          <v-col cols="12" md="4" sm="6" class="text-center">
            <v-icon size="35" color="primary">mdi-phone</v-icon>
            <p class="mt-2">
              <strong>Phone:</strong> <br />
              +977-056-503147, <br />
              +977-9845468646
              <!-- {{ statedata.schoolPhone }} -->
            </p>
          </v-col>
          <v-col cols="12" md="4" sm="6" class="text-center">
            <v-icon size="35" color="primary">mdi-email</v-icon>
            <p class="mt-2">
              <strong>Email:</strong> <br />
              meroprintexpress@gmail.com
              <!-- {{ statedata.schoolEmail }} -->
            </p>
          </v-col>
        </v-row>

        <v-row class="pa-4 justify-space-between" style="min-height: 300px">
          <!-- Left: Google Map -->
          <v-col cols="12" md="5" class="d-flex">
            <v-sheet class="flex-grow-1">
              <v-responsive :aspect-ratio="1">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1766.7422496409242!2d84.4035716!3d27.6714166!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3994fb3bb93bea15%3A0x120da2494438c4f1!2sBro%20Soft%20Pvt%20Ltd!5e0!3m2!1sen!2snp!4v1743051860875!5m2!1sen!2snp"
                  width="600"
                  height="450"
                  style="width: 100%; height: 100%; border-radius: 8px"
                  allowfullscreen
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </v-responsive>
            </v-sheet>
          </v-col>

          <!-- Right: Contact Form -->
          <v-col cols="12" md="6" class="d-flex">
            <v-sheet
              class="flex-grow-1 d-flex flex-column justify-between pa-4"
            >
              <p>Please fill up the below form if you have any feedback:</p>
              <v-form
                @submit.prevent="handleSubmit"
                ref="formRef"
                v-model="formValid"
                class="d-flex flex-column"
                style="flex-grow: 1"
              >
                <v-text-field
                  v-model="form.name"
                  label="Your Full Name"
                  outlined
                  dense
                  required
                  :rules="nameRules"
                />

                <v-text-field
                  v-model="form.email"
                  label="Your Email Address"
                  type="email"
                  outlined
                  dense
                  required
                  :rules="emailRules"
                />

                <v-text-field
                  v-model="form.contact"
                  label="Your Phone number"
                  type="tel"
                  dense
                  placeholder="+977 XXX-XXX-XXXX"
                  required
                  :rules="contactRules"
                />

                <v-textarea
                  v-model="form.message"
                  label="Your Message"
                  outlined
                  dense
                  required
                  :rules="messageRules"
                />

                <v-btn type="submit" color="primary" class="mt-4" block>
                  Send Message
                </v-btn>
              </v-form>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    <!-- </v-card> -->
    <HowWork />
    <WhyUs />
    <!-- <Footer @update-contact-info="contactStore.updateContactInfo" /> -->
    <Footer />
  </div>
</template>

<style scoped>
.banner {
  position: relative;
  width: 100%;
  height: 500px;
  /* Adjust based on your desired height */
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Ensures the image covers the banner area without distortion */
}

.banner-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  color: white;
  font-weight: bold;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.6);
  /* Optional shadow for better visibility */
}

h2 {
  font-weight: bold;
  text-align: center;
  color: #343434;
}

.text-primary {
  color: #4caf50;
}

.font-weight-bold {
  font-weight: bold;
}

.custom-input {
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
  border: 2px solid #ddd;
  transition: all 0.3s ease-in-out;
}

.custom-input:focus {
  outline: none;
  border-color: #4caf50;
  box-shadow: 0 0 8px rgba(76, 175, 80, 0.4);
}

.custom-button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 15px;
  font-size: 1.1rem;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.custom-button:hover {
  background-color: #388e3c;
  transform: translateY(-2px);
}

.custom-button:active {
  background-color: #2c6b2f;
  transform: translateY(0);
}

.map-container iframe {
  border-radius: 8px;
}

.container {
  margin-top: 40px;
  margin-bottom: 40px;
}

.form-control-lg {
  padding: 1rem;
  font-size: 1.1rem;
}

.mb-3 {
  margin-bottom: 1rem;
}
</style>
